export const userDataCookieConstants = {
    USER_DATA_COOKIE_CHANGE_EVENT: 'userDataCookieChange',
    USER_DATA_COOKIE_NAME: window.appState.ssoConfig.cookieStorage.userDataCookieName
};
